import React, { Children, cloneElement } from 'react';
import styled, { css } from 'styled-components/macro';
import { props as shouldFprops } from '@styled-system/should-forward-prop';

import { rem, themeGetCss } from '@blueprint/ui';

import Box from '../Box';
import { _BRPConflictProps } from '../utils.contants';

const ListItemWrapper = styled(Box).withConfig({
  shouldForwardProp: (prop) =>
    ![...shouldFprops, ..._BRPConflictProps].includes(prop),
})`
  ${themeGetCss('list.base')}
  ${({ listStyleType }) =>
    listStyleType !== 'none' &&
    css`
      list-style: ${listStyleType};
    `}
  ${({ listStyleColor }) =>
    listStyleColor === 'highBrand' &&
    css`
      list-style: none;

      &::before {
        content: '\\2022';
        color: #db0011;
        font-weight: bold;
        display: inline-block;
        width: 1.2em;
        margin-left: -1.2em;
      }
    `}
  ${({ listStylePosition, listStyleColor }) =>
    listStylePosition === 'inside' &&
    listStyleColor === 'highBrand' &&
    css`
      &::before {
        margin-left: 0;
      }
    `};
  ${({ customIcon }) =>
    customIcon &&
    css`
      display: flex;
    `}
  ${({ customIcon, listStylePosition }) =>
    listStylePosition === 'inside' &&
    customIcon &&
    css`
      display: block;
      transform: initial;

      & > div[data-testid='Icon'] {
        float: left;
        margin-right: ${rem(10)};
      }
    `}
`;

const ListItem = ({
  children,
  customIcon = false,
  listStyleColor = 'default',
  listStylePosition,
  listStyleType,
  ...rest
}) => {
  return typeof children !== 'string' ? (
    <ListItemWrapper
      as="li"
      customIcon={customIcon}
      listStylePosition={listStylePosition}
      listStyleColor={listStyleColor}
      listStyleType={listStyleType}
      {...rest}
    >
      {Children.map(children, (child) =>
        // @ts-ignore
        cloneElement(child, {
          listStylePosition,
          customIcon,
          listStyleColor,
        }),
      )}
    </ListItemWrapper>
  ) : (
    <ListItemWrapper
      listStyleColor={listStyleColor}
      listStylePosition={listStylePosition}
      customIcon={customIcon}
      as="li"
      {...rest}
    >
      {children}
    </ListItemWrapper>
  );
};

ListItem.displayName = 'ListItem';

export default ListItem;
